import "./LaunchingSoon.css";
import logo from "../../../Images/Brand/menuWithname.png";
import { Helmet } from "react-helmet";

// Social Links
import facebook from "../../../Images/Social/facebook.png";
import instagram from "../../../Images/Social/instagram.png";
const LaunchingSoon = () => {
    return (
        <>
            <div className="UnderConstruction">
                <Helmet>
                    <title>Skillsverse Academy | Best Online Classes for Programming & Tech Skills Coming Soon</title>
                    <meta
                        name="description"
                        content="Skillsverse Academy is launching soon! Learn programming, web development, and IT skills from expert instructors."
                    />
                    <meta
                        name="keywords"
                        content="Skillsverse Academy, Coming Soon, Online Classes, Programming, Web Development, IT Training, Coding, Nepal"
                    />
                    <meta name="robots" content="index, follow" />

                    {/* Open Graph / Facebook */}
                    <meta property="og:type" content="website" />
                    <meta property="og:title" content="Skillsverse Academy | Coming Soon" />
                    <meta
                        property="og:description"
                        content="Skillsverse Academy is launching soon! Learn programming, web development, and IT skills from expert instructors."
                    />
                    <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
                    <meta property="og:url" content="https://skillsverseacademy.com" />

                    {/* Twitter */}
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Skillsverse Academy | Coming Soon" />
                    <meta
                        name="twitter:description"
                        content="Skillsverse Academy is launching soon! Learn programming, web development, and IT skills from expert instructors."
                    />
                    <meta name="twitter:image" content="%PUBLIC_URL%/favicon.ico" />
                </Helmet>

                <div className="topleft"></div>
                <div className="topright"></div>
                <div className="bottomleft"></div>
                <div className="bottomright"></div>

                {/* <DotBackground/> */}
                <div className="textContainer">
                    <h1>We’re Building Something Great!</h1>
                    <p>
                        Skillsverse Academy website is currently under development.
                        Coming soon with courses,<br/> resources, and enrollment details.
                    </p>
                    <img src={logo} alt="Skillsverse Academy | Logo" />
                </div>
                <div className="imageUnder">




                    <div className="links">
                        <p className="intro">Skillsverse Academy is a Nepal-based online platform helping learners gain practical skills in programming, web, and IT.</p>
                        <div className="line"></div>
                        <div className="social">
                            <a href="https://www.facebook.com/profile.php?id=61582579791427"><img src={facebook} alt="Skillsverse Academy | Facebook"></img></a>
                            <a href="https://www.instagram.com/skillsverseacademy/"><img src={instagram} alt="Skillsverse Academy | Instagram"></img></a>
                        </div>
                        <div className="line"></div>
                        <p>
                            skillsverseacademy@gmail.com<br />
                            skillsverseacademy.com
                        </p>
                    </div>
                </div>
            </div >
        </>
    )
}
export default LaunchingSoon;